import QuizGame from "./QuizGame";
import QuizMenu from "./QuizMenu";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<QuizMenu />} />
        <Route path="/quizGame/:quizFile/:quizMode" element={<QuizGame />} /> {/* รับพารามิเตอร์ quiz file */}
      </Routes>
    </Router>
  );
}

export default App;
